import React, { useState, useEffect, useCallback } from 'react'
import './pageStyles/tech.min.css'
import Header from '../components/header/header'
import PageHeading from '../components/pageHeading/index'
import PlanetImage from '../components/planetImage/index'
import RoundedTabs from '../components/roundedTabs/index'
import HeroDescription from '../components/heroDescription/index'

const Technology = ({
  techData
}) => {
    // This is to set the background coz i've been having some trouble setting the background of the various pages using CSS
    const desktopBG = "url('/assets/technology/background-technology-desktop.jpg')"
    const mobileBG = "url('/assets/technology/background-technology-mobile.jpg')"
    
    const memoizedScreenCheck = useCallback(() => {
      if (window.innerWidth < 1000) {
        document.body.style.backgroundImage = mobileBG
      } else {
        document.body.style.backgroundImage = desktopBG
      }
    }, [window.innerWidth])
  
    useEffect(() => {
      memoizedScreenCheck()
    }, [memoizedScreenCheck])

  // Statefull Elements
  const [currentTech, setCurrentTech] = useState({
    data: techData[0],
    active: 1
  })
  const handleCurrentTech = (number) => {
    const numb = parseInt(number)
    setCurrentTech({
      data: techData[numb - 1],
      active: numb
    })
  }

  console.log('TECH')

  return(
    <div className="container">
      <Header activeLink='4'/>
      <div className="MainContainer padding-16" style={{ minHeight: 'fit-content' }}>
        <PageHeading number="03" text="SPACE LAUNCH 101"/>
      </div>

      <div className="MainContainer display-container">
        <div className="TechTabPanel MainChild padding-64 margin-bottom">
          {/* This currentTech.active is a number passed down as a prop */}
          <RoundedTabs
            number="3" active={currentTech.active} 
            handleCurrentTech={handleCurrentTech}
          />
          <div className="margin-left" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <HeroDescription
              smallText='THE TECHNOLOGY...'
              mainTextMedium={currentTech.data.name}
              description={currentTech.data.description}
            />
          </div>
        </div>  
        <div className="display-container">
          <div className="TechImage">
            <PlanetImage image={currentTech.data.images.portrait} name={currentTech.data.name} />
          </div>
        </div>
      </div>
    </div>
  )
}



export default Technology